import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useAdminExportTransactionType = () => {
  return useMutation({
    mutationFn: async (transactionTypeId: string) => {
      const response = await apiClient.transactionType.exportTransactionType.mutation({ params: { transactionTypeId }, responseType: 'blob' });
      return { data: response, transactionTypeId };
    },
    onSuccess: ({ data, transactionTypeId }) => {
      const blob = new Blob([JSON.stringify(data.body, null, 2)], { type: 'application/json' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `transactionType-${transactionTypeId}.json`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      toast.success('TransactionType export downloaded successfully');
    },
    onError: (error: any) => {
      showErrorToast(error, 'Error exporting transactionType');
    },
  });
};
